<template>
  <div class="profile px-8">
    <ApolloMutation
      class="settings-seo__header py-8"
      :mutation="mutation"
      :variables="model"
      @done="updateComplete"
      @loading="updateLoading = $event"
      @error="printError($event)"
      :update="updateCache"
    >
      <template v-slot="{ mutate }">
        <ProfileActions
          :disabled="!validForm || !dirty"
          @update="mutate()"
          root-name="Gestione Utenti"
          element-name="Crea nuovo"
        />
      </template>
    </ApolloMutation>
    <div class="py-10">
      <!-- Result -->
      <div class="result apollo">
        <div class="text-error" v-if="customError">{{ customError }}</div>
        <ProfileFields
          v-bind="model.input"
          :update-loading="updateLoading"
          :require-password="true"
          @valid="validForm = $event"
          @update="updateData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileActions from '@/components/ProfileActions'
import ProfileFields from '@/components/ProfileFields'
import CREATE_USER from '@/graphql/CreateEditor.gql'
import GET_USERS from '@/graphql/GetEditors.gql'

export default {
  components: {
    ProfileActions,
    ProfileFields,
  },

  data() {
    return {
      dirty: false,
      validForm: false,
      updateLoading: false,
      mutation: CREATE_USER,
      model: {
        input: {
          email: '',
          displayName: '',
          password: '',
        },
      },
      customError: '',
      newId: null,
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.shouldExit(next)
  },

  beforeRouteLeave(to, from, next) {
    this.shouldExit(next)
  },

  methods: {
    updateComplete() {
      this.updateLoading = false
      this.markAsClean()

      this.$router.push({
        name: 'EditUser',
        params: { id: this.newId, tenant: this.$route.params.tenant },
      })
    },

    printError(err) {
      this.updateComplete()

      if (
        err.gqlError &&
        err.gqlError.extensions &&
        err.gqlError.extensions.code === 'instance not unique'
      ) {
        this.customError = 'Email già in uso'
      }

      console.error(err)
    },

    updateCache(store, res) {
      let data = null
      const query = {
        query: GET_USERS,
      }

      try {
        data = store.readQuery(query)
      } catch {
        // empty cache
      }

      if (data) {
        data.allEditors.data.push(res.data.createEditor)
        store.writeQuery({ ...query, data })
      }

      this.newId = res.data.createEditor._id
    },

    updateData(event) {
      if (event.dirty) {
        this.markAsDirty()
      } else {
        this.markAsClean()
      }

      Object.keys(event.modelData).forEach(key => {
        this.$set(this.model.input, key, event.modelData[key])
      })

      this.customError = ''
    },

    markAsClean() {
      this.dirty = false
    },

    markAsDirty() {
      this.dirty = true
    },

    shouldExit(next) {
      if (this.dirty) {
        if (
          confirm(
            'Uscire dalla pagina? Alcune modifiche non sono state salvate.',
          )
        ) {
          this.markAsClean()
          next()
          return
        } else {
          next(false)
          return
        }
      }

      next()
    },
  },
}
</script>
